/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowextend2Inputs */

const en_aiflowextend2 = /** @type {(inputs: Aiflowextend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend the background with AI`)
};

const de_aiflowextend2 = /** @type {(inputs: Aiflowextend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund mit KI erweitern`)
};

/**
* | output |
* | --- |
* | "Extend the background with AI" |
*
* @param {Aiflowextend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowextend2 = /** @type {((inputs?: Aiflowextend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowextend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowextend2(inputs)
	return de_aiflowextend2(inputs)
});
export { aiflowextend2 as "aiFlowExtend" }